import React from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";


const LeftMenu = ({ mode }) => {
  return (
    <Menu className="fEstedad-bold " mode={mode}>
      <Menu.Item style={{color:"#a23854"}} key="explore">
      <Link to="/choose-product">  
      سفارش چاپ
          </Link>
        </Menu.Item>
      <Menu.Item style={{color:"#a23854"}} key="features">

        <Link to="/products">  
        محصولات
          </Link>
        </Menu.Item>
      <Menu.Item style={{color:"#a23854"}} key="about">
      <Link to="/about-us">  
      درباره ی ما
          </Link>
        
        </Menu.Item>
      <Menu.Item style={{color:"#a23854"}} key="contact">
      <Link to="/contact-us">  
      تماس با ما
          </Link>
        </Menu.Item>
    </Menu>
  );
};

export default LeftMenu;